import { gql } from "@apollo/client";

/**
 * Cancellations — maps 1:1 to `api/src/cancellations/cancellations.resolver.ts`
 * plus the raw personal-send mutation on the Chat Automations resolver.
 */

const CANCELLATION_RESULT_FIELDS = `
  kind
  days
  total
  groups {
    key
    category
    tier
    title
    subtitle
    template
    count
    members {
      userId
      firstName
      name
      email
      country
      endsAt
      endDate
      daysLeft
      planId
      eventsAttended
      message
    }
  }
`;

export const SCHEDULED_CANCELLATIONS = gql`
  query adminScheduledCancellations($days: Int!) {
    adminScheduledCancellations(days: $days) {
      ${CANCELLATION_RESULT_FIELDS}
    }
  }
`;

export const TRIAL_CANCELLATIONS = gql`
  query adminTrialCancellations($days: Int!) {
    adminTrialCancellations(days: $days) {
      ${CANCELLATION_RESULT_FIELDS}
    }
  }
`;

/** Send each member her own exact message (greeting included), no prefix added. */
export const SEND_PERSONAL_MESSAGES = gql`
  mutation ChatAutomationsSendPersonalMessages($input: SendPersonalMessagesInput!) {
    chatAutomationsSendPersonalMessages(input: $input) {
      total
      sendId
      succeeded
      failed
      notFound
      skipped
    }
  }
`;
